import { motion } from "framer-motion";

const EASE = [0.25, 0.6, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 20, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.55, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", delay = 0, gap = 0.07 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.12 }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: gap, delayChildren: delay } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y: 18 }, show: { opacity: 1, y: 0 } }}
    transition={{ duration: 0.5, ease: EASE }}
  >
    {children}
  </motion.div>
);
